module.exports = __webpack_public_path__ + "static/scale-model-of-the-grace-museum-in-abilene-texas-a5caaad366eea0c57ff971965e50bbec.png";